import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import WalletButton from './WalletButton';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Features', href: '#features' },
    { name: 'How to Play', href: '#how-to-play' },
    { name: 'NFTs', href: '#nfts' },
    { name: 'Tokenomics', href: '#tokenomics' },
    { name: 'Roadmap', href: '#roadmap' },
    { name: 'FAQ', href: '#faq' }
  ];

  return (
    <header className="fixed top-0 w-full bg-black border-b border-[rgba(255,255,255,0.25)] z-50">
      <div className="max-w-[1400px] mx-auto px-[7.6923%] h-20 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img 
            src="/logo.png" 
            alt="PIOFarming Game Logo" 
            className="h-20 w-auto object-contain"
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-[rgba(255,255,255,0.75)] hover:text-[#00FFD1] text-lg font-medium transition-colors duration-300"
            >
              {link.name}
            </a>
          ))}
        </nav>

        {/* Desktop Wallet Button */}
        <div className="hidden lg:block">
          <WalletButton />
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="lg:hidden text-white"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-black border-t border-[rgba(255,255,255,0.25)]">
          <nav className="flex flex-col px-[7.6923%] py-6 gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="text-[rgba(255,255,255,0.75)] hover:text-[#00FFD1] text-lg font-medium transition-colors duration-300"
              >
                {link.name}
              </a>
            ))}
            <div className="mt-4">
              <WalletButton />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
